import {
  FETCH_SUBCOLLECTIONS_REQUEST,
  FETCH_SUBCOLLECTIONS_SUCCESS,
  FETCH_SUBCOLLECTIONS_FAILURE,
  ADD_SUBCOLLECTION_REQUEST,
  ADD_SUBCOLLECTION_SUCCESS,
  ADD_SUBCOLLECTION_FAILURE,
  UPDATE_SUBCOLLECTION_REQUEST,
  UPDATE_SUBCOLLECTION_SUCCESS,
  UPDATE_SUBCOLLECTION_FAILURE,
  DELETE_SUBCOLLECTION_REQUEST,
  DELETE_SUBCOLLECTION_SUCCESS,
  DELETE_SUBCOLLECTION_FAILURE,
  SET_SUBCOLLECTION_EDIT,
  CLEAR_SUBCOLLECTION_EDIT,
} from '../../../../types/masters/styles/subCollection/subCollectionTypes';
import {
  fetchSubCollections,
  addSubCollection,
  updateSubCollection,
  deleteSubCollection,
} from '../../../../../api/masters/styles/subCollection/subCollectionApi';

export const fetchSubCollectionsAction = () => async (dispatch) => {
  dispatch({ type: FETCH_SUBCOLLECTIONS_REQUEST });
  try {
    const data = await fetchSubCollections();
    dispatch({ type: FETCH_SUBCOLLECTIONS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: FETCH_SUBCOLLECTIONS_FAILURE, payload: error.message });
  }
};

export const addSubCollectionAction = (subCollection) => async (dispatch) => {
  dispatch({ type: ADD_SUBCOLLECTION_REQUEST });
  try {
    await addSubCollection(subCollection);
    dispatch({ type: ADD_SUBCOLLECTION_SUCCESS });
    dispatch(fetchSubCollectionsAction());
  } catch (error) {
    dispatch({ type: ADD_SUBCOLLECTION_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateSubCollectionAction = ({ id, subCollection }) => async (dispatch) => {
  dispatch({ type: UPDATE_SUBCOLLECTION_REQUEST });
  try {
    const data = await updateSubCollection(id, subCollection);
    dispatch({ type: UPDATE_SUBCOLLECTION_SUCCESS, payload: data });
    dispatch(fetchSubCollectionsAction());
  } catch (error) {
    dispatch({ type: UPDATE_SUBCOLLECTION_FAILURE, payload: error.message });
    throw error;
  }
};

export const deleteSubCollectionAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_SUBCOLLECTION_REQUEST });
  try {
    await deleteSubCollection(id);
    dispatch({ type: DELETE_SUBCOLLECTION_SUCCESS, payload: id });
    dispatch(fetchSubCollectionsAction());
  } catch (error) {
    dispatch({ type: DELETE_SUBCOLLECTION_FAILURE, payload: error.message });
    throw error;
  }
};

export const setSubCollectionEdit = (subCollection) => ({
  type: SET_SUBCOLLECTION_EDIT,
  payload: subCollection,
});

export const clearSubCollectionEdit = () => ({
  type: CLEAR_SUBCOLLECTION_EDIT,
}); 